import { useEffect, useState, useCallback } from "react";
import localApi from "@/lib/localApi";
import { useAuth } from "@/context/AuthContext";

/** Fetches the unread notification count for the signed-in user and refreshes on interval / focus. */
export default function useUnreadNotifications(intervalMs = 30000) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) {
      setCount(0);
      return;
    }
    try {
      const { data } = await localApi.get("/notifications/unread-count");
      setCount(Number(data?.count || 0));
    } catch {
      /* silent */
    }
  }, [user]);

  useEffect(() => {
    refresh();
    if (!user) return;
    const id = setInterval(refresh, intervalMs);
    const onFocus = () => refresh();
    const onCustom = () => refresh();
    window.addEventListener("focus", onFocus);
    window.addEventListener("nd_notifications_changed", onCustom);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("nd_notifications_changed", onCustom);
    };
  }, [refresh, user, intervalMs]);

  return { count, refresh };
}
